import gql from 'graphql-tag';
import { RESPONSE_TYPE } from './ResponseType.gql';

export const EMAIL_PREDICTION_REPORT_QUERY = gql`
  ${RESPONSE_TYPE}
  query emailPredictionReport($responseId: ID!) {
    emailPredictionReport(responseId: $responseId) {
      ...ResponseType
    }
  }
`;
